import { c as _c } from "react/compiler-runtime";
/**
 * useResizableComposer Hook
 *
 * Provides drag-to-resize functionality for the message composer.
 * Allows users to click and drag to adjust the height of the textarea.
 */

import { useState, useCallback, useEffect, useRef } from 'react';
type UseResizableComposerOptions = {
  minHeight?: number; // Minimum height in pixels
  maxHeight?: number; // Maximum height in pixels
  initialHeight?: number; // Initial height in pixels
};
export function useResizableComposer(t0) {
  const $ = _c(17);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? {} : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    minHeight: t2,
    maxHeight: t3,
    initialHeight: t4
  } = t1;
  const minHeight = t2 === undefined ? 80 : t2;
  const maxHeight = t3 === undefined ? 600 : t3;
  const initialHeight = t4 === undefined ? 80 : t4;
  const [height, setHeight] = useState(initialHeight);
  const [isDragging, setIsDragging] = useState(false);
  const dragStartY = useRef(0);
  const dragStartHeight = useRef(0);
  let t5;
  if ($[2] !== height) {
    t5 = e => {
      e.preventDefault();
      setIsDragging(true);
      dragStartY.current = e.clientY;
      dragStartHeight.current = height;
    };
    $[2] = height;
    $[3] = t5;
  } else {
    t5 = $[3];
  }
  const handleDragStart = t5;
  let t6;
  if ($[4] !== isDragging || $[5] !== maxHeight || $[6] !== minHeight) {
    t6 = e_0 => {
      if (!isDragging) {
        return;
      }
      const deltaY = dragStartY.current - e_0.clientY;
      const newHeight = dragStartHeight.current + deltaY;
      const clampedHeight = Math.max(minHeight, Math.min(maxHeight, newHeight));
      setHeight(clampedHeight);
    };
    $[4] = isDragging;
    $[5] = maxHeight;
    $[6] = minHeight;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const handleDragMove = t6;
  let t7;
  if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = () => {
      setIsDragging(false);
    };
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  const handleDragEnd = t7;
  let t8;
  let t9;
  if ($[9] !== handleDragMove || $[10] !== isDragging) {
    t8 = () => {
      if (isDragging) {
        window.addEventListener("mousemove", handleDragMove);
        window.addEventListener("mouseup", handleDragEnd);
        document.body.style.cursor = "ns-resize";
        document.body.style.userSelect = "none";
        return () => {
          window.removeEventListener("mousemove", handleDragMove);
          window.removeEventListener("mouseup", handleDragEnd);
          document.body.style.cursor = "";
          document.body.style.userSelect = "";
        };
      }
    };
    t9 = [isDragging, handleDragMove, handleDragEnd];
    $[9] = handleDragMove;
    $[10] = isDragging;
    $[11] = t8;
    $[12] = t9;
  } else {
    t8 = $[11];
    t9 = $[12];
  }
  useEffect(t8, t9);
  let t10;
  if ($[13] !== handleDragStart || $[14] !== height || $[15] !== isDragging) {
    t10 = {
      height,
      isDragging,
      handleDragStart
    };
    $[13] = handleDragStart;
    $[14] = height;
    $[15] = isDragging;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}